// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
  margin: 0;
  font-family: Arial, sans-serif;
  color: #fff;
}

.App {
  text-align: center;
}

/* Common layout for every page */
.dashboard-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.dashboard-layout {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  margin-top: 60px; /* Offset for the fixed header */
}

.dashboard-main {
  flex-grow: 1;
  transition: margin-left 0.3s ease;
  margin-left: 0;
}

.dashboard-main.sidebar-open {
  margin-left: 250px; 
}

.dashboard-content {
  padding: 1rem;
  background-color: #f5f5f5;
  height: calc(100% - 60px); /* Adjust height to account for the header */
  overflow-y: auto;
  margin-top: 20px; /* Additional spacing for better visual clarity */
}

.dashboard-content h2 {
  color: #000;
  margin-top: 0;
  padding-top: 10px;
}

.dashboard-content p {
  color: #000;
  margin-top: 10px;
  padding-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB,EAAE,4CAA4C;EACvE,gBAAgB;EAChB,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["\nbody {\n  margin: 0;\n  font-family: Arial, sans-serif;\n  color: #fff;\n}\n\n.App {\n  text-align: center;\n}\n\n/* Common layout for every page */\n.dashboard-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.dashboard-layout {\n  display: flex;\n  flex-grow: 1;\n  overflow: hidden;\n  margin-top: 60px; /* Offset for the fixed header */\n}\n\n.dashboard-main {\n  flex-grow: 1;\n  transition: margin-left 0.3s ease;\n  margin-left: 0;\n}\n\n.dashboard-main.sidebar-open {\n  margin-left: 250px; \n}\n\n.dashboard-content {\n  padding: 1rem;\n  background-color: #f5f5f5;\n  height: calc(100% - 60px); /* Adjust height to account for the header */\n  overflow-y: auto;\n  margin-top: 20px; /* Additional spacing for better visual clarity */\n}\n\n.dashboard-content h2 {\n  color: #000;\n  margin-top: 0;\n  padding-top: 10px;\n}\n\n.dashboard-content p {\n  color: #000;\n  margin-top: 10px;\n  padding-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
